function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var mobile_flag = false;
    for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
            mobile_flag = true;
            break
        }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;
    if (screen_width < 500 && screen_height < 768) {
        mobile_flag = true
    }
    if (screen_width > 768) {
        mobile_flag = false
    }
    return mobile_flag
}
if (IsPC() == true) {
    $(window).load(function() {
        $(".Two").simpleSlideTwo();
        $("#full_feature").swipeslider({
            autoPlay: false,
            prevNextButtons: false,
            bullets: false
        })
    });
    function FunImg() {
        $(".sw-slide").removeClass("hide");
        $("#full_feature").width($("img.no-js.lazypreload").width());
        $("#full_feature").height($("img.no-js.lazypreload").width())
    }
    $(function() {
        $(window).resize(function() {
            $("#full_feature").css("height", $("img.no-js.lazypreload").width())
        });
        FunImg()
    })
} else {
    $(window).load(function() {
        $(".Two").simpleSlideTwo();
        //$(".product-photo-thumbs li:first-child").addClass("change");
        $("body").on("click", ".product-photo-thumbs li",
        function() {
            $(".product-photo-thumbs li").removeClass("change");
            $(this).addClass("change")
        })
    });
    $("#full_feature").width();
    $("#full_feature").css("height", $("#full_feature").width());
    //$(".sw-slide.lazyload__image-wrapper:eq(0)").removeClass("hide")
};

/*星級start*/
$(function(){
	var timer;
    timer=setInterval(function(){ 
    	searchStar()
    }, 1000);
  function searchStar(){
  	var el=$("#ProductSection .product-meta--review .spr-badge");
    if(el){
       var grade=el.attr("data-rating");
       if(grade){
         var gradeStr=grade+'';
         gradeStr=grade.substring(0,3)
         //el.find(".spr-badge-caption").append(" - "+gradeStr+" grade");
         
         if(grade==5){
         }else if(grade<5 && grade>=4){
         	var elS=el.find(".spr-badge-starrating .spr-icon").eq(4);
            elS.append("<span style='width:50%'></span>");
           
         }else if(grade<4 && grade>=3){
            el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
         	var elS=el.find(".spr-badge-starrating .spr-icon").eq(3);
            elS.append("<span style='width:50%'></span>");
         }else if(grade<3 && grade>=2){
            el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
            el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
         	var elS=el.find(".spr-badge-starrating .spr-icon").eq(2);
            elS.append("<span style='width:50%'></span>");
         }else if(grade<2 && grade>=1){
            el.find(".spr-badge-starrating .spr-icon").eq(2).hide();
            el.find(".spr-badge-starrating .spr-icon").eq(3).hide();
            el.find(".spr-badge-starrating .spr-icon").eq(4).hide();
         	var elS=el.find(".spr-badge-starrating .spr-icon").eq(1);
            elS.append("<span style='width:50%'></span>");
         }else{
         	el.find(".spr-badge-starrating .spr-icon").hide();
            var elS=el.find(".spr-badge-starrating .spr-icon").eq(0);
            elS.show();
            elS.append("<span style='width:50%'></span>");
         }
         $(".template-product .product-meta--review .spr-badge").show();
         
         if($("#shopify-product-reviews .spr-header .spr-starrating").html()){
            var starString=$(".template-product .product-meta--review .spr-starrating").html()
         	$("#shopify-product-reviews .spr-header .spr-starrating").html(starString);
            $("#shopify-product-reviews .spr-header .spr-starrating").after('<span class="spr-summary-actions">'+gradeStr+' grade</span>');
            $("#shopify-product-reviews .spr-header .spr-starrating").show()
            clearInterval(timer)
         }
         
       }
    }
  }
    
})
/*星級end*/


//折扣start
//复制折扣碼
$(function(){
	var clipboard = new Clipboard('.copyBtn');
  $(".copyBtn").click(function(){
      layer.open({
        title: 'information',
        time: 2000, //2s后自动关闭
        shadeClose: true, //开启遮罩关闭
        btn: ['confirm'], //按钮
        skin: 'layui-layer-rim', //加上边框
        content: '<div class="layer-code"><p>Congratulation!Use the code at checkout</p></div>'
      });
  })
})

//判断时间
$(function(){
    var discountPNum=0;
	$(".discountTable .discountP").each(function(){
      var  isshow=1
      var etime=$(this).attr("etime");
      etime=etime.replace(/-/g,"/");
      var stime=$(this).attr("stime");
      stime=stime.replace(/-/g,"/");
      var title2=$(this).attr("title")
      var title=$(this).find("a").html();
      if(stime){
      	 var dS=new Date(stime+" EDT")
         var timestampS=dS.getTime()
         var dN=new Date()
         var timestampN=dN.getTime();
         if(timestampS>timestampN){
        	/*title+='COMING SOON';
           $(this).find("a").html(title);
           $(this).find(".code").hide();*/
           $(this).remove();
            isshow=0;
         }
      }
      if(etime){
          var dE=new Date(etime+" EDT")
          var timestampE=dE.getTime()
          var dN=new Date()
          var timestampN=dN.getTime();
          if(timestampN>timestampE){
            $(this).remove();
            isshow=0;
          }
      }
      //展示优惠红色
      if(isshow==1){
      	discountPNum++;
      }
      if(isshow==1 && discountPNum==1){
        $(".product-photo-container .yh .yh-title").html(title2)
        var yhHtml=$(".product-photo-container .yh").html();
        $(".product-photo-container .yh").html(yhHtml).show();
        
        
        if(etime){
            var dE=new Date(etime+" EDT")
            var timestampE=dE.getTime()
            var dN=new Date()
            var timestampN=dN.getTime();
            var timeGap=timestampE-timestampN;
          if($(".dealBox").html()){
            $(" .template-product .dealBox").show();
            dealFun(timeGap);
          }
           
        }
        var showOriginalPrice=$(this).attr("showOriginalPrice");
        // if(showOriginalPrice!='true'){
        // 	$("#productPrice-product-template").before('<span class="originalTr">Original</span>');
        // }
      }
  })
  //获得折扣价
  getDiscountPice()
  if(discountPNum<=0){
    $(".discountTable").remove();
  }
})

//倒计时
function dealFun(timeGap){
	var timer=setInterval(function(){
            timeGap=timeGap-1000;
            if(timeGap>0){
				var data=getTimeGAp(timeGap);
                $(".dealBox .dGap").html(data['dGap']);
                $(".dealBox .hGap").html(data['hGap']);
                $(".dealBox .minutesGap").html(data['minutesGap']);
                $(".dealBox .secondsGap").html(data['secondsGap']);
                 
            }else{
            	$(" .template-product .dealBox").hide();
                $(".template-product .product-photo-container .yh").hide();
            }
     },1000);
  
}
function getTimeGAp(timeGap){
  var data;
  var dGap=timeGap/86400000;
  dGap=Math.floor(dGap);
  
  timeGap=timeGap-dGap*86400000
  var hGap=timeGap/3600000;
  hGap=Math.floor(hGap);

  timeGap=timeGap-hGap*3600000;
  var minutesGap=timeGap/60000;
  minutesGap=Math.floor(minutesGap);

  timeGap=timeGap-minutesGap*60000;
  var secondsGap=timeGap/1000;
  secondsGap=Math.floor(secondsGap);
  
  
  if(dGap<10){
    dGap="0"+dGap;
  } 
  if(hGap<10){
    hGap="0"+hGap
  }
  if(minutesGap<10){
    minutesGap="0"+minutesGap
  }
  if(secondsGap<10){
    secondsGap='0'+secondsGap
  }
  data={
    'dGap':dGap,
    'hGap':hGap,
    'minutesGap':minutesGap,
    'secondsGap':secondsGap
  }
  return data;
}

//折扣end

//获得折扣价
function getDiscountPice(){
  	$(".discountTable .discountP").each(function(){
      var showOriginalPrice=$(this).attr("showOriginalPrice");
      if(showOriginalPrice!='true'){
      	var discountNum=$(this).attr("discountnum");
      	var discountType=$(this).attr("discounttype");
        var price=$("meta[itemprop='price']").attr('content');
        var discountPrice=price;
        if(discountType=="Fixed amount"){
          discountPrice=price-discountNum;
          discountPrice=discountPrice.toFixed(2);
        }else if(discountType=='Percentage'){
          discountPrice=price*(1-discountNum*0.01);
          discountPrice=discountPrice.toFixed(3)
          discountPrice=discountPrice*100;
          discountPrice=Math.ceil(discountPrice);
          discountPrice=discountPrice/100;
          discountPrice=discountPrice.toFixed(2);
        }
        if(discountPrice>0){

        }else{
          discountPrice=price;
        }
         $(this).find(".discount-price").html("<span class='discount-price-unit'>$</span>"+discountPrice);
      }
    })
}
